<template><!-- svgo-optimised -->
<svg class="icon icon__minus" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none"><path d="M4.507 8.493v.494h6.986V8H4.507v.493" fill="currentColor" fill-rule="evenodd"/></svg>
</template>